import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Art = () => {
  const gradePrograms = [
    {
      grade: "K - 1",
      title: "Foundation Skills",
      content: "K - 1 students learn about the Principles of Art: Line, Shape, Balance, Pattern, as well as Color Mixing, Art Vocabulary and how to use different media: Drawing, Painting, Sculpture, Collage. We view and discuss famous artworks and connect them to other areas, such as math and science. Mr. Widem reads us art storybooks which further these connections.",
      skills: ["Line & Shape", "Balance & Pattern", "Color Mixing", "Art Vocabulary", "Drawing", "Painting", "Sculpture", "Collage"]
    },
    {
      grade: "2nd - 5th",
      title: "Advanced Projects",
      content: "2nd - 5th students take their art knowledge and apply it to more complicated projects such as intricate Hispanic and African masks, Hispanic food made from clay, highly detailed buildings made from paper, portraits, Impressionistic painting, sculpted flowers, drawings about Peace…and much more! We listen to art storybooks, read art articles and work on our \"Art of the Month,\" where we study a famous artwork and write about it.",
      skills: ["Hispanic & African Masks", "Clay Sculptures", "Architectural Drawings", "Portrait Art", "Impressionistic Painting", "Sculpted Flowers", "Peace Drawings", "Art of the Month"]
    }
  ];

  return (
    <main id="main-content" className="bg-white">
      <Navbar />
      
      {/* Header Section */}
      <section className="pt-32 pb-24 bg-[#630503] relative overflow-hidden">
        <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 bottom-0 h-1/5 bg-gradient-to-b from-[#630503] to-white"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <div className="mb-16">
              <span className="inline-block bg-white/10 backdrop-blur-sm text-white px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] mb-8 rounded-full">
                Creative Expression
              </span>
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-light text-white mb-8 leading-[1.1] max-w-4xl mx-auto">
                P.S. 11X <span className="font-bold">Art Program</span>
              </h1>
              <div className="w-24 h-px bg-white/40 mx-auto mb-8"></div>
              <p className="text-lg lg:text-xl leading-relaxed text-white/95 max-w-3xl mx-auto">
                Teaching students artistic skills and art history to create, appreciate, and connect art to our everyday lives.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Program Goals & Mission */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Program <span className="font-bold text-[#630503]">Goals</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <div className="max-w-4xl mx-auto">
              <p className="text-lg text-gray-600 leading-relaxed">
                The goal of Mr. Widem's Art Program is to teach students artistic skills and give them a background in art history so that they can not only create art, but also learn to appreciate it and see how it connects the world and how it's part of our everyday lives in math, science and many other areas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Grade Level Programs */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Grade Level <span className="font-bold text-[#630503]">Curriculum</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Our art curriculum builds foundational skills in early grades and advances to complex creative projects as students develop.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {gradePrograms.map((program, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
                <div className="bg-[#630503] p-6">
                  <h3 className="text-2xl font-semibold text-white mb-2">Grades {program.grade}</h3>
                  <p className="text-white/90">{program.title}</p>
                </div>
                <div className="p-8">
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {program.content}
                  </p>
                  <div className="border-t border-gray-200 pt-6">
                    <h4 className="text-sm font-semibold text-gray-900 mb-4 uppercase tracking-wider">Key Focus Areas</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {program.skills.map((skill, skillIndex) => (
                        <span key={skillIndex} className="inline-block bg-[#630503]/10 text-[#630503] px-3 py-1 rounded-full text-xs font-medium">
                          {skill}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Student Artwork Showcase */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Student <span className="font-bold text-[#630503]">Artwork</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Explore the creative expressions and artistic achievements of our P.S. 11X students.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* After School Art Classes */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">After School Art Classes</h3>
                <div className="bg-gray-200 rounded-lg h-80 flex items-center justify-center mb-6 overflow-hidden">
                  <img 
                    src="/assets/images/art/after-school-art-classes.jpg" 
                    alt="Students painting in after school art class" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Students work on diverse projects that combine creativity with curriculum connections, from basic art principles to advanced cultural and historical art studies in our extended learning programs.
                </p>
              </div>
            </div>

            {/* Math Integration Project */}
            <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <div className="p-8">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Unit on Shapes to connect to Math Curriculum</h3>
                <div className="bg-gray-200 rounded-lg h-80 flex items-center justify-center mb-6 overflow-hidden">
                  <img 
                    src="/assets/images/art/shapes-math-curriculum.jpg" 
                    alt="Students holding geometric shapes in art class" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Students explore geometric shapes through art, creating hands-on connections between mathematical concepts and creative expression in Mr. Widem's integrated curriculum approach.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Community & Family Programs */}
      <section className="py-20 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Community <span className="font-bold text-[#630503]">Programs</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Extending art education beyond the classroom through family engagement and community partnerships.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Paint Nights */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="bg-amber-600 p-6">
                <h3 className="text-2xl font-semibold text-white mb-2">PAINT NIGHTS WITH P.S. 11 FAMILIES</h3>
              </div>
              <div className="p-8">
                <div className="bg-gray-200 rounded-lg h-64 flex items-center justify-center mb-6 overflow-hidden">
                  <img 
                    src="/assets/images/art/paint-nights-families.jpg" 
                    alt="Families painting together during paint night event" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Family paint nights create opportunities for parents and students to create art together, building community connections while exploring creativity in a supportive environment.
                </p>
              </div>
            </div>

            {/* After School Program */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
              <div className="bg-[#630503] p-6">
                <h3 className="text-2xl font-semibold text-white mb-2">After School Art Classes</h3>
              </div>
              <div className="p-8">
                <div className="bg-gray-200 rounded-lg h-64 flex items-center justify-center mb-6">
                  <div className="text-center text-gray-600">
                    <div className="text-6xl mb-4">🖌️</div>
                    <p className="text-lg font-medium">After School Art</p>
                    <p className="text-sm">Extended learning opportunities</p>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Extended art programming provides additional creative opportunities for students to develop their artistic skills beyond regular school hours.
                </p>
                <div className="bg-amber-50 border border-amber-200 p-4 rounded-lg">
                  <p className="text-sm font-medium text-gray-900 mb-1">Contact for Information:</p>
                  <a href="mailto:cwidem@schools.nyc.gov" className="text-[#630503] font-semibold hover:underline">
                    cwidem@schools.nyc.gov
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Educational Trips */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-light text-gray-900 mb-8">
              Educational <span className="font-bold text-[#630503]">Experiences</span>
            </h2>
            <div className="w-24 h-px bg-[#630503]/40 mx-auto mb-8"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Bringing art education to life through museum visits and real-world cultural experiences.
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden max-w-4xl mx-auto">
            <div className="p-8">
              <h3 className="text-2xl font-semibold text-gray-900 mb-6">Museum trips! (this was our Guggenheim Museum trip in Manhattan)</h3>
              <div className="bg-gray-200 rounded-lg h-96 flex items-center justify-center mb-6 overflow-hidden">
                <img 
                  src="/assets/images/art/guggenheim-museum-trip.jpg" 
                  alt="P.S. 11X students and staff at Guggenheim Museum"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-gray-600 leading-relaxed mb-6">
                Educational museum trips provide students with firsthand exposure to world-class art collections, helping them connect classroom learning with professional artistic works and cultural institutions.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h4 className="font-semibold text-gray-900 mb-2">Cultural Exposure</h4>
                  <p className="text-sm text-gray-600">Students experience diverse artistic styles and cultural perspectives</p>
                </div>
                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h4 className="font-semibold text-gray-900 mb-2">Art History</h4>
                  <p className="text-sm text-gray-600">Connecting classroom lessons with famous artworks and artists</p>
                </div>
                <div className="bg-white p-4 rounded-lg border border-gray-200">
                  <h4 className="font-semibold text-gray-900 mb-2">Inspiration</h4>
                  <p className="text-sm text-gray-600">Inspiring future artistic endeavors and creative thinking</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact & Information */}
      <section className="py-20 bg-[#630503]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl lg:text-4xl font-light text-white mb-8">
              Connect with Our <span className="font-bold">Art Program</span>
            </h2>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mb-12">
              Mr. Widem and the P.S. 11X Art Program are here to inspire creativity and artistic growth in every student.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12">
              <div className="text-center">
                <h3 className="text-xl font-semibold text-white mb-4">Art Teacher</h3>
                <p className="text-white/80 mb-2">Mr. Widem</p>
                <a href="mailto:cwidem@schools.nyc.gov" className="text-white/80 hover:text-white underline">
                  cwidem@schools.nyc.gov
                </a>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-semibold text-white mb-4">Program Focus</h3>
                <p className="text-white/80 mb-2">Art Skills & History</p>
                <p className="text-white/80">Cross-Curricular Connections</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="mailto:cwidem@schools.nyc.gov"
                className="bg-white text-[#630503] hover:bg-white/90 font-semibold px-8 py-4 text-base transition-colors rounded-lg"
              >
                Contact Mr. Widem
              </a>
              <button className="bg-white/10 border border-white/30 text-white hover:bg-white/20 font-semibold px-8 py-4 text-base transition-colors rounded-lg">
                Learn More About Art Classes
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default Art; 